__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "contact-experience-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/api", "5.4.5", () => (Promise.all([__webpack_require__.e(7744), __webpack_require__.e(2473), __webpack_require__.e(9669), __webpack_require__.e(6249)]).then(() => (() => (__webpack_require__(82473))))));
			register("@mui/material", "5.14.10", () => (Promise.all([__webpack_require__.e(3728), __webpack_require__.e(5383), __webpack_require__.e(8416), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(83728))))));
			register("@mui/x-license", "7.12.0", () => (Promise.all([__webpack_require__.e(8416), __webpack_require__.e(3262)]).then(() => (() => (__webpack_require__(93262))))));
			register("@reduxjs/toolkit", "1.9.5", () => (Promise.all([__webpack_require__.e(949), __webpack_require__.e(513)]).then(() => (() => (__webpack_require__(20991))))));
			register("amazon-connect-streams", "2.14.6", () => (__webpack_require__.e(2226).then(() => (() => (__webpack_require__(92226))))));
			register("aws-appsync", "4.1.9", () => (Promise.all([__webpack_require__.e(7744), __webpack_require__.e(2178), __webpack_require__.e(949), __webpack_require__.e(6720), __webpack_require__.e(6733)]).then(() => (() => (__webpack_require__(96720))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(2178), __webpack_require__.e(5142)]).then(() => (() => (__webpack_require__(65142))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(6245).then(() => (() => (__webpack_require__(96245))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(3935), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-draggable", "4.4.5", () => (Promise.all([__webpack_require__.e(1193), __webpack_require__.e(8416), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(61193))))));
			register("react-redux", "8.1.2", () => (Promise.all([__webpack_require__.e(6706), __webpack_require__.e(8416), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(86706))))));
			register("react", "18.2.0", () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(8416), __webpack_require__.e(1256)]).then(() => (() => (__webpack_require__(91256))))));
			register("superagent", "8.1.2", () => (Promise.all([__webpack_require__.e(569), __webpack_require__.e(8185)]).then(() => (() => (__webpack_require__(80569))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};